module.exports = __webpack_public_path__ + "static/media/recent-blog2.7f0c64d8.jpg";